import { ParallaxLayer } from '@react-spring/parallax'
import { Card, Carousel } from 'react-bootstrap';
import React, { useState } from 'react'
import './style.scss'
import { carouselSlideCardCount, PredeterminedMySkills } from './predeterminedConstants';
import useWindowSize from '../../../../hooks/useWindowSize';

function HomeMySkills() {
  const [page, setPage] = useState(0);
  const [windowWidth] = useWindowSize();

  const handleSelect = (selectedPage, e) => {
    setPage(selectedPage);
  };

  function renderSkillGroupPage(skillGroup) {
    return (
      <Carousel.Item style={{height: '70vh'}}>
        <div className='my-skills-page'>
        {
          skillGroup.map((skill) =>
            <Card className={'my-skills-card'}>
              <Card.Img variant='top' src={skill.imageUrl} className={'my-skills-image-container'} />
              <Card.Header as='h1'>{skill.name}</Card.Header>
              <Card.Body>
                {skill.message}
              </Card.Body>
            </Card>
            )
        }
        </div>
      </Carousel.Item>
    )
  }

  function renderCarousel() {
    const mySkills = [];
    const cardCount = carouselSlideCardCount(windowWidth);
    for (let i = 0; i < PredeterminedMySkills.length; i += cardCount) {
      mySkills.push(PredeterminedMySkills.slice(i, i + cardCount));
    }
    console.log(mySkills)
    
    return (
      <Carousel activeIndex={page} onSelect={handleSelect} className={'my-skills-carousel'} fade nextLabel='' prevLabel=''>
        { mySkills.map((skillGroup) => renderSkillGroupPage(skillGroup)) }
      </Carousel>
    )
  }

  return (
    <ParallaxLayer offset={4} className={'my-skills-container'}>
      <div className={'my-skills-title'}>My <b>Skills</b></div>
      <div className={'my-skills-carousel-placeholder'}>
        { renderCarousel() }
      </div>
    </ParallaxLayer>
  )
}

export default HomeMySkills
